import { render, staticRenderFns } from "./NhProductsPage.vue?vue&type=template&id=8719877c"
import script from "./NhProductsPage.vue?vue&type=script&lang=js"
export * from "./NhProductsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports